import styled from 'styled-components'

const MyDiv = styled.div`
.main{
  border-radius: 10px;
  overflow:hidden;
  filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.15));
  border-width:1px;
}

  .page_heading{
    margin-bottom: 2px;
}
.flex_header{
    align-items: center;
    justify-content: space-between;
}

  .profile-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    max-height: 100vh;
  }

  .fixed-header {
    flex-shrink: 0;
    padding:0px 16px 16px 16px;
    background-color: white;
    z-index: 1;
  }

.bg-filter {
    background: rgba(0, 0, 0, 0.1);
    height: 1px;
    width: 100%;
  }
.Badge{
  border-radius: 16px;
  text-decoration:underline;
  display: flex;
  align-items:center;
  gap:4px;
  height:19px
}

.designation{
  border-radius: 4px;
}

.history_btn {
  border: 0.5px solid #000000;
  border-radius: 22px;
  padding: 5px 16px;
  background: #f9f9f9;
}

`
export default MyDiv
